module.exports = __webpack_public_path__ + "img/oildata.0fae17f0.png";